document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll("section");
  const navLinks = document.querySelectorAll("nav a");
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;

          navLinks.forEach((link) => {
            link.classList.toggle(
              "active",
              link.getAttribute("href") === `#${id}`
            );
          });
        }
      });
    },
    {
      threshold: 0.6, // section must be 60% visible
    }
  );

  sections.forEach((section) => observer.observe(section));

  mobileMenuToggle.addEventListener("click", () => {
    document.querySelector("nav").classList.toggle("active");
  });
});